import type { SilaeCredentialSchema } from '@libs/data-access/entities'
import { useMutation } from '@tanstack/react-query'

import type {
  NewApiErrorResponse,
  UseAppMutationOptions
} from '../../../../types'
import type { PostSilaeCredentialOption } from '../silae.credentials.api'
import { postSilaeCredential } from '../silae.credentials.api'
import { silaeCredentialsCacheKeys } from '../silae.credentials.cacheKeys'

export const usePostSilaeCredential = (
  mutationOptions?: UseAppMutationOptions<
    SilaeCredentialSchema,
    NewApiErrorResponse,
    PostSilaeCredentialOption
  >
) => {
  return useMutation<
    SilaeCredentialSchema,
    NewApiErrorResponse,
    PostSilaeCredentialOption
  >({
    ...mutationOptions,
    mutationKey: silaeCredentialsCacheKeys.create_silae_credentials(),
    mutationFn: opts => postSilaeCredential(opts)
  })
}
